import { recordFromSnapshot } from 'utils/firebaseUtils'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_CONSO_ERROR = 'CREATE_CONSO_ERROR'
export const CREATE_CONSO_SUCCESS = 'CREATE_CONSO_SUCCESS'
export const DELETE_CONSO_ERROR = 'DELETE_CONSO_ERROR'
export const DELETE_CONSO_SUCCESS = 'DELETE_CONSO_SUCCESS'
export const UPDATE_CONSO_ERROR = 'UPDATE_CONSO_ERROR'
export const UPDATE_CONSO_SUCCESS = 'UPDATE_CONSO_SUCCESS'
export const SELECT_CONSO = 'SELECT_CONSO'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectConso(conso) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_CONSO,
      payload: conso
    })
  }
}
export function getCatTaxes(category, consos) {
  return (dispatch, getState) => {
    let taxes = 20 // init taxes
    for (let i = 0; i < consos.length; i++) {
      // go through all consos
      for (const elem in consos[i]) {
        // go through all categories
        if (consos[i][elem] === category) {
          // if category matches the selected category
          // set taxes to the corresponding value of the category via the first element
          taxes = consos[i][Object.keys(consos[i])[0]].taxes
        }
      }
    }
    return taxes
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createConso(category, name, price, taxes, qty) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const conso = {
      name: name,
      price: price,
      taxes: taxes,
      quantity: qty
    }
    firebase.child('consos/' + category).push(conso, error => {
      if (error) {
        console.error('ERROR @ createCONSO :', error)
        dispatch({
          type: CREATE_CONSO_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteConso(category, drinkId) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('consos/' + category + '/' + drinkId).remove(error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: DELETE_CONSO_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateConso(category, drinkId, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase
      .child('consos/' + category + '/' + drinkId)
      .update(changes, error => {
        if (error) {
          console.error('ERROR @ updateConso :', error)
          dispatch({
            type: UPDATE_CONSO_ERROR,
            payload: error
          })
        }
      })
  }
}

export function registerConsosListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('consos')

    ref.on('child_added', snapshot =>
      dispatch({
        type: CREATE_CONSO_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_changed', snapshot =>
      dispatch({
        type: UPDATE_CONSO_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_CONSO_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createConso,
  updateConso,
  registerConsosListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_CONSO_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(conso => conso.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_CONSO_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_CONSO_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(conso => {
        return conso.key === action.payload.key ? action.payload : conso
      })
    }),
  [UPDATE_CONSO_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_CONSO_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(conso => {
        return conso.key !== action.payload.key
      })
    }),
  [DELETE_CONSO_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CONSO]: (state, action) =>
    Object.assign({}, state, { selectedConso: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedConso: {} }
export default function tableReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/conso.js